import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
} from "@mui/material";
import HeaderComponent from "../components/HeaderComponent";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
import Language from "../languages";

export default function CodeProcessPage() {
  const navigate = useNavigate();
  const mall = useSelector((state) => state.mall);
  const language = useSelector((state) => state.language);
  const [code, setCode] = useState("");

  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4, mx: 2 }}>
        <HeaderComponent
          left="back"
          middle="logo"
          right="icon"
          goBack={() => navigate(-1)}
        />

        <Box sx={{ marginTop: 5 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: 14,
              fontWeight: 600,
              color: "rgba(117, 117, 117, 1)",
              marginBottom: 2,
            }}
          >
            {Language(mall, language, "codeProcess")}
          </Typography>

          <TextField
            label={Language(mall, language, "code")}
            variant="outlined"
            fullWidth
            value={code}
            onChange={(e) => setCode(e.target.value)}
            inputProps={{ inputMode: "numeric" }}
            sx={{
              marginBottom: 3,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                fontSize: 14,
              },
              "& .MuiInputLabel-root": {
                fontSize: 14,
              },
            }}
          />

          <Button
            variant="contained"
            color="newRed"
            fullWidth
            disabled={!code.trim()}
            sx={{
              paddingY: 1.5,
              fontWeight: 700,
              fontSize: 14,
              textTransform: "none",
              borderRadius: 2,
            }}
            onClick={() => navigate("/code-form", { state: { code } })}
          >
            {Language(mall, language, "continue")}
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
